import React, { FunctionComponent } from 'react'
import { OnBenchPlayerProps } from '../PlayerTypes'
import TeamMemberTemplate from '../template'

const OnBenchPlayer: FunctionComponent<Omit<OnBenchPlayerProps, 'type'>> = ({
    name,
    imageUrl,
    onPressRow,
    testID,
    additionalInfoIconsList,
    jerseyNumber,
    imageAlt,
    showBorderBottom,
}) => {
    return (
        <TeamMemberTemplate
            name={name}
            testID={testID}
            imageUrl={imageUrl}
            onPressRow={onPressRow}
            jerseyNumber={jerseyNumber}
            additionalInfoIconsList={additionalInfoIconsList}
            imageAlt={imageAlt}
            showBorderBottom={showBorderBottom}
        />
    )
}

export default OnBenchPlayer
